exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-detail .pro-detail .cont img{\r\n  max-width: 100%;\n}\n.page-detail .countdown-inner {\r\n  font-size: 16px;\n}\n.page-detail .countdown-inner span {\r\n  padding: 0 3px;\r\n  margin-right: 3px;\r\n  background-color: #3ca26c;\r\n  color: #fff;\n}\n.page-detail .countdown-inner i {\r\n  font-style: normal;\r\n  padding: 0 2px;\r\n  margin-right: 3px;\n}\n.page-detail .weui-cells {\r\n  font-size: 16px;\n}\r\n", ""]);

// exports
